module.exports = __webpack_public_path__ + "img/testimonials-3.481522e7.jpg";